import { render, staticRenderFns } from "./KemperFwrLima_1d00_Kaskade.vue?vue&type=template&id=49a6df4f&"
import script from "./KemperFwrLima_1d00_Kaskade.vue?vue&type=script&lang=js&"
export * from "./KemperFwrLima_1d00_Kaskade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports